export const PRODUCT_CLASSIFICATION = {
  develop: 'develop',
  select: 'select',
  staffing: 'staffing',
};

export const REPORT_TYPE = {
  development: 'development',
  coaching: 'coaching',
  staffing: 'staffing',
};
